import { BaseController } from '@maia/feature-utils';
import {
  CmsProductDetailsDto,
  CmsProductIntroDto,
  CmsService,
} from '@maia/shared';

export class CmsController extends BaseController {
  constructor(private cmsService: CmsService) {
    super();
  }

  async getProductIntro(
    params: Parameters<typeof this.cmsService.getProductIntro>[0],
  ) {
    const response = await this.cmsService.getProductIntro(params);
    return response.map((res) => new CmsProductIntroDto(res));
  }

  async getProductDetails(
    params: Parameters<typeof this.cmsService.getProductDetails>[0],
  ) {
    const response = await this.cmsService.getProductDetails(params);
    return new CmsProductDetailsDto(response);
  }
}
